import { useRef } from 'react';

import Card from 'components/card/Card';
import DatesMore from 'components/dates-more/DatesMore';

import { IEventCardList } from 'source/NFR.types';

const EventCardList: React.FC<IEventCardList> = ({ list }) => {
  const datesMoreRef = useRef<HTMLDivElement>(null);

  if (!list || list.length === 0) {
    return null;
  }

  return (
    <ul className="event-card-list">
      {list.map(({ eventCard, moreDates, date }) => (
        <li className="event-card-list__item" key={eventCard.title}>
          <Card {...eventCard} isEvent sizes="(min-width: 1024px) 33vw, (min-width: 600px) 50vw, 100vw" />
          <div className="event-card-list__dates">
            {date && (
              <time dateTime={date} className="event-card-list--date">
                {date}
              </time>
            )}
            {moreDates && <DatesMore className="event-card-list--dates-more" {...moreDates} refProp={datesMoreRef} />}
          </div>
        </li>
      ))}
    </ul>
  );
};

EventCardList.displayName = 'EventCardList';

export default EventCardList;
